import cn from "classnames"
import { Field, FieldProps } from "formik"
import React, { ChangeEvent } from "react"

import imgClear from "./assets/clear.svg"
import styles from "./index.module.css"

type InputProps = JSX.IntrinsicElements["input"] & {
  label: string
  type?: string
  active?: boolean
  error?: boolean
  isActive?: boolean
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  onClear?: () => void
}

export const Input: React.FC<InputProps> = ({
  className,
  label,
  type = "text",
  error,
  value,
  defaultValue,
  onChange,
  onClear,
  ...properties
}) => (
  <div
    className={cn(styles.Wrapper, className, {
      [styles.WithClearBtn]: onClear,
    })}
  >
    <input
      className={cn({
        [styles._active]: !!value || !!defaultValue,
        [styles._error]: error,
      })}
      defaultValue={defaultValue}
      id={label}
      type={type}
      value={value}
      onChange={onChange}
      {...properties}
    />

    {onClear && value !== "" && (
      <div className={styles.Clear} onClick={onClear}>
        <img src={imgClear} />
      </div>
    )}

    <label htmlFor={label}>{label}</label>
  </div>
)

type FormInput = {
  label: string
  type?: string
  active?: boolean
  className?: string
  name: string
  disabled?: boolean
}

export const FormInput: React.FC<FormInput> = ({
  className,
  label,
  type = "text",
  name,
  ...properties
}) => (
  <Field name={name}>
    {({ field, meta }: FieldProps) => (
      <Input
        className={className}
        error={!!meta.error && meta.touched}
        label={label}
        type={type}
        value={meta.value}
        {...field}
        {...properties}
      />
    )}
  </Field>
)
